export enum ChannelType {
    VOICE = 'voice',
    DIGITAL_EMAIL = 'digitalEmail',
    DIGITAL_SMS = 'digitalSMS',
    DIGITAL_MSG = 'digitalMsg',
}
